/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HotelPropertyContentRoom
 */
export interface HotelPropertyContentRoom {
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentRoom
     */
    roomId?: number;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentRoom
     */
    roomCode?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentRoom
     */
    roomType: string;
    /**
     * 
     * @type {string}
     * @memberof HotelPropertyContentRoom
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof HotelPropertyContentRoom
     */
    facilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HotelPropertyContentRoom
     */
    bedDescriptions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof HotelPropertyContentRoom
     */
    views?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentRoom
     */
    bedroomCount?: number;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentRoom
     */
    areaSqFeet?: number;
    /**
     * 
     * @type {number}
     * @memberof HotelPropertyContentRoom
     */
    maxAdults?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HotelPropertyContentRoom
     */
    accessible?: boolean;
}

/**
 * Check if a given object implements the HotelPropertyContentRoom interface.
 */
export function instanceOfHotelPropertyContentRoom(value: object): value is HotelPropertyContentRoom {
    if (!('roomType' in value) || value['roomType'] === undefined) return false;
    return true;
}

export function HotelPropertyContentRoomFromJSON(json: any): HotelPropertyContentRoom {
    return HotelPropertyContentRoomFromJSONTyped(json, false);
}

export function HotelPropertyContentRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelPropertyContentRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['room_id'] == null ? undefined : json['room_id'],
        'roomCode': json['room_code'] == null ? undefined : json['room_code'],
        'roomType': json['room_type'],
        'description': json['description'] == null ? undefined : json['description'],
        'facilities': json['facilities'] == null ? undefined : json['facilities'],
        'bedDescriptions': json['bed_descriptions'] == null ? undefined : json['bed_descriptions'],
        'views': json['views'] == null ? undefined : json['views'],
        'bedroomCount': json['bedroom_count'] == null ? undefined : json['bedroom_count'],
        'areaSqFeet': json['area_sq_feet'] == null ? undefined : json['area_sq_feet'],
        'maxAdults': json['max_adults'] == null ? undefined : json['max_adults'],
        'accessible': json['accessible'] == null ? undefined : json['accessible'],
    };
}

export function HotelPropertyContentRoomToJSON(json: any): HotelPropertyContentRoom {
    return HotelPropertyContentRoomToJSONTyped(json, false);
}

export function HotelPropertyContentRoomToJSONTyped(value?: HotelPropertyContentRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'room_id': value['roomId'],
        'room_code': value['roomCode'],
        'room_type': value['roomType'],
        'description': value['description'],
        'facilities': value['facilities'],
        'bed_descriptions': value['bedDescriptions'],
        'views': value['views'],
        'bedroom_count': value['bedroomCount'],
        'area_sq_feet': value['areaSqFeet'],
        'max_adults': value['maxAdults'],
        'accessible': value['accessible'],
    };
}

